import { render, staticRenderFns } from "./WalletSettings.vue?vue&type=template&id=99eb51dc"
import script from "./WalletSettings.vue?vue&type=script&lang=js"
export * from "./WalletSettings.vue?vue&type=script&lang=js"
import style0 from "./WalletSettings.vue?vue&type=style&index=0&id=99eb51dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WalletSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports